import axios from 'axios'     // 引入axios
import apiList from './api'   // 引入API列表
import { MessageBox, Message } from 'element-ui'
import apiComponents from "./components"
// import {Toast} from 'vant'
import Vue from 'vue'
import store from '../store'
import $common from '../common/common'
import { Loading, Alert } from 'element-ui'
import CryptoJS from 'crypto-js'
var timeoutNum
// var JudgeNum = 0
Vue.use(Loading);
// const vueObject = new Vue({});
const vueObject = new Vue({
    store,
});
// service 循环遍历输出不同的请求方法
let instance = axios.create({
    baseURL: vueObject.$store.getters.getConfig.requestUrl,
    // timeout: 4000,
})
const Http = {};  //请求方法的容器
// 请求格式/参数的统一
function nameApi(argdata) {
    for (let key in argdata) {
        let api = argdata[key] // url

        Http[key] = async function (
            params, // 请求参数 get:url,put,post,patch(data),delete:url
            isFormData = false,
            config = {}, //配置参数
        ) {
            if (api.config) {
                config = api.config
            }
            config.headers = config.headers ? config.headers : {}
            if (api.config && !api.config.noPassJur) {
                config.headers.jurId = sessionStorage.getItem('printJurId'); //操作记录
            }
            // console.log(config.headers)
            var userInfo = vueObject.$store.getters.getUserInfo
            if (userInfo != false) {
                ////AES加密
                // var key = CryptoJS.enc.Utf8.parse('dfsoft.soft.1501');//秘钥
                // // 要加密的字符串
                // var data = sessionStorage.getItem('token') + new Date(new Date()).getTime()
                // // 加密
                // var encrypted = CryptoJS.AES.encrypt(data, key, {
                //     mode: CryptoJS.mode.ECB,
                //     padding: CryptoJS.pad.Pkcs7
                // });
                // config.headers.token = encrypted.toString()
                config.headers.token = sessionStorage.getItem('token')
            }
            // let newParams = params
            let newParams = {}
            // content-type 是否是form-data
            if (params && isFormData) {
                // form-data转换
                newParams = new FormData()
                for (var i in params) {
                    if (typeof (params[i]) == 'array') {
                        var osnParams = {},
                            osnParams = new FormData()
                        for (let j in params[i]) {
                            osnParams.append(j, params[i][j])
                        }
                        newParams.append(i, osnParams)
                    } else {
                        newParams.append(i, params[i])
                    }
                }
            } else {
                newParams = params
            }
            // 不同请求的判断
            let response = {}; //请求的返回值
            if (api.method === 'put' || api.method === 'post' || api.method === 'patch') {
                config.data = true
                // put，post,patch请求
                try {
                    response = await instance[api.method](api.url, newParams, config)
                    // console.log(response)
                } catch (err) {
                    response = err
                }
            } else if (api.method === 'delete' || api.method === 'get') {
                config.data = true
                // delete,get请求
                config.params = newParams
                try {
                    response = await instance[api.method](api.url, config)
                } catch (err) {
                    response = err
                }
            }

            if (response.status == 400) {
                window.parent.postMessage({ cmd: 'login', message: response.message });
                vueObject.$common.pageJump('./login')
                $common.remove()
            }
            // vueObject.$common.console(response.status);
            return response
        }
    }
}
nameApi(apiList)
nameApi(apiComponents)
let loading;
function startLoading() {    //使用Element loading-start 方法
    loading = Loading.service({
        lock: true,
        text: '加载中...',
        background: 'rgba(255, 255, 255, 0.4)',
    })
}
function endLoading() {    //使用Element loading-close 方法
    loading.close()
}
function open() {
    MessageBox.confirm('服务器连接失败，请检查当前网络环境!', '警告', {
        confirmButtonText: '确定',
        showCancelButton: false,
        type: 'error'
    }).then(() => {

    }).catch(() => {

    });
}
var configUrl = ""
// 请求拦截器的添加
instance.interceptors.request.use(config => {
    if (config.url == "/Organization/queryAll") {
        configUrl = config.url
    }
    if (
        config.url == '/Login/online' ||
        config.url == '/publicNotice/queryShowNotices' ||
        config.url == '/Login/acquireOrm' ||
        config.url == '/menuRecord/addMenuRecord' ||
        config.url == '/applyInvoicing/getFaceState' ||
        config.url == '/orderMsg/getByOrderKey'
        // || config.url == '/Jurisdiction/personquery'
    ) { } else {
        startLoading();
    }
    return config
})
var indexNum=0
// 响应拦截器
instance.interceptors.response.use(
    async res => {
        if (res.data.status == 200 && res.config.url == "/Organization/queryAll") {
            clearTimeout(timeoutNum)
        }
        if (res.status !== 200) {
            Message({
                message: res.message || '数据请求发生错误',
                type: 'error',
                duration: 2 * 1000
            })
        }
        endLoading()
        return res.data
    },
    // 服务器状态码不是200的情况
    async error => {
        if (configUrl == "/Organization/queryAll") {
            indexNum++
        }
        //设置业务逻辑
        endLoading()
        if (configUrl == "/Organization/queryAll"&&indexNum==1) {
            open()
        } else {
            return error
        }
    })
export default Http